//-------------------------------------------------------------------------
// blocks selecting delay when the target combatant is the only active
// combatant in the current action who has not yet committed an action.
// `no_action` counts as having taken an action for this check.
//-------------------------------------------------------------------------
export default function isLastCurrentActionDelaySelection(parm) {
  if (parm.selected_action?.name !== 'delay') {
    return false
  }

  if (parm.view_round !== parm.arena_round) {
    return false
  }

  if (parm.arena_action <= 0 || parm.num !== parm.arena_action) {
    return false
  }

  const targetCombatant = parm.props?.row
  if (!targetCombatant) {
    return false
  }

  const caName = `ca_name${parm.arena_action}`
  const caType = `ca_type${parm.arena_action}`
  const hasTakenActionInCurrentCA = (combatant) => {
    const slotName = String(combatant?.[caName] || '')
      .trim()
      .toLowerCase()
    const slotType = String(combatant?.[caType] || '')
      .trim()
      .toLowerCase()

    if (!slotName || slotName === 'blank' || slotName === 'pending') {
      return false
    }

    return slotType === 'action'
  }

  const currentActionCombatants = (parm.combatants ?? []).filter(
    (combatant) =>
      combatant.status !== 'Inactive' &&
      combatant[caName] !== undefined &&
      combatant[caName] !== 'blank',
  )

  if (currentActionCombatants.length === 0) {
    return false
  }

  if (hasTakenActionInCurrentCA(targetCombatant)) {
    return false
  }

  const otherCombatantsStillToAct = currentActionCombatants.filter(
    (combatant) => combatant.id !== targetCombatant.id && !hasTakenActionInCurrentCA(combatant),
  )

  return otherCombatantsStillToAct.length === 0
}
